"use client";
import React from "react";
import Avatar from "components/common/Avatar";
import { useAuthStore } from "stores";
import { get } from "utils/lodash";

interface AccountHeaderProps {
  layout?: "primary" | "default";
}

export default function AccountHeader({ layout = "primary" }: AccountHeaderProps) {
  const { user } = useAuthStore();
  const userName = get(user, "name", "");
  const userAvatar = get(user, "avatar", "");
  const userId = get(user, "id", "");

  return (
    <div className={`w-full flex flex-col items-center pt-6 pb-4 rounded-b-xl ${layout === "primary" ? "bg-primary" : "bg-white"}`}>
      <Avatar
        src={userAvatar}
        name={userName}
        size="xlarge"
        gradientSeed={userId}
        alt="user-avatar"
      />
      <div className={`text-md text-center mt-4 ${layout === "primary" ? "text-white" : "text-gray-800"}`}>
        {!userName ? "Đăng nhập để quản lý cửa hàng của bạn" : userName}
      </div>
    </div>
  );
}